<p>
  Ние сме екип от ентусиасти, колекционери и специалисти в областта на електронната търговия, обединени от идеята да
  създадем сигурна, удобна и ефективна платформа за покупко-продажба на колекционерски предмети.
</p>
<p>
  Нашата мисия е да свързваме хора със споделени интереси – независимо дали става дума за монети, банкноти, значки,
  книги, фигурки или други ценни и редки предмети. Платформата е създадена с внимание към детайла, с фокус върху
  прозрачността, доверието и сигурността на всяка сделка.
</p>
<p class="mb-1">
  Ние не просто предоставяме техническа среда – ние изграждаме общност. Вярваме, че доверието между потребителите е
  ключът към устойчивата търговия и позитивното изживяване. Затова отделяме особено внимание на:
</p>
<ul>
  <li>системата за отзиви и рейтинг;</li>
  <li>сигурните методи за потвърждение на сделки;</li>
  <li>инструменти за комуникация между купувачи и продавачи;</li>
  <li>и активно съдействие при възникване на спорове.</li>
</ul>
<p>
  Collectoria.bg е онлайн платформа, администрирана от „Нумизмат“ ЕООД– българско дружество, регистрирано по Търговския
  закон, чиято основна дейност е създаване и поддържане на специализирани онлайн среди за търговия. Компанията е
  ангажирана с осигуряване на сигурна, изчистена и ненатрапчива търговска среда – сайтът не използва бисквитки за
  проследяване, не съдържа реклами и не допуска странични влияния върху съдържанието.
</p>
<p class="mb-1">
  В платформата потребителите могат:
</p>
<ul>
  <li>да публикуват обяви на фиксирана цена или като онлайн търг (аукцион);</li>
  <li>да участват безплатно в наддавания на чужди обяви;</li>
  <li>да купуват стоки от други потребители чрез директна покупка или чрез спечелване на търг.</li>
</ul>
<p>
  Всички транзакции се потвърждават от страните, а комуникацията и разплащанията се извършват директно между
  потребителите. Collectoria.bg не е страна по сделките, но предоставя цялата необходима инфраструктура и контролирани
  механизми, за да ги улесни.
</p>
<div class="m-0 alert alert-primary">
  <strong>Нашата цел:</strong> Да изградим доверена и устойчива общност от колекционери и търговци, в която всяка обява,
  сделка и комуникация протичат сигурно, прозрачно и с взаимно уважение. Стремим се да създадем пространство, в което
  страстта към колекционирането среща коректността на търговията.
</div>

